module.exports = __webpack_public_path__ + "static/media/web-Design.7ef0b577.png";